import React from "react"

export default function TypeConditionalCheckbox({ value }) {
  return <div>{value} </div>
}
